import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MatomoRegisterService } from '@mare-common/ngx-mare-common';
import { GoogleAnalyticsService } from './google-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private matomoRegisterService: MatomoRegisterService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    console.log('NavigationService constructor');
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        try{
          this.matomoRegisterService.sendEvent({
          category: 'page_view',
          action: 'page_view',
          name: event.urlAfterRedirects
        });
        } catch(e){
          console.log('NavigationService matomo error', e);
        }

        try{
          this.googleAnalyticsService.logPageView(event.urlAfterRedirects);
        } catch(e){
          console.log('NavigationService google error', e);
        }
        
      }
    });
  }
}
